import React from 'react'
import Banner from './banner'
import Why from './why'
import Model from './model'
import WhatBuilds from './what-builds'
import Transformation from './transformation'
import Philosophy from './philosophy'
import Discovery from './discovery'
import Price from './price'
import Pathway from './pathway'
import Gives from './gives'
import NotFree from './not-free'
import Colleges from './colleges'
import Speakers from './speakers'
import Partner from './partner'
import TransformationModel from './1000-students'
import { MdOutlineWhatsapp } from 'react-icons/md'
import FishingStory from './fishing-story'
import ViralArticle from './viral-article'
import Faq from './faq'
import Header from '../../header'
import Slot from './slot'

export default function SurgeStudents() {
    
    return (
        <div className='relative overflow-hidden w-full'>
            <Header />
            <Banner />
            <Pathway />
            <Why />
            <Model />
            <WhatBuilds />
            <FishingStory />
            <ViralArticle />
            <Transformation />
            <Philosophy />
            <Discovery />
            <Price />
            <Slot />
            <Gives />
            <NotFree />
            <Colleges />
            <Speakers />
            <Partner />
            <TransformationModel />
            <Faq />
            <div className='border-t border-[#1E2939] text-[12px] md:text-[14px] text-[#99A1AF] font-normal p-[20px] md:px-[42px] text-center flex flex-row-reverse lg:flex-row justify-end lg:justify-between flex-wrap gap-[30px] lg:items-center mx-auto bg-[#000]'>
                <div>
                    <div className='flex flex-wrap gap-[10px]'>
                        <p className='cursor-pointer' onClick={() => window.location.href = "/privacy"}>Privacy</p>
                        <p className='cursor-pointer' onClick={() => window.location.href = "/terms-and-conditions"}>Terms</p>
                        <p className='cursor-pointer' onClick={() => window.location.href = "/contact"}>Contact</p>
                        <p className='cursor-pointer' onClick={() => window.location.href = "/about"}>About</p>
                        <p className='cursor-pointer' onClick={() => window.location.href = "/refund"}>Refund</p>
                    </div>
                    <p className='mt-[10px] text-start'>© 2025 Surge Students. All rights reserved..</p>
                </div>
                <div className='w-full md:w-auto'>
                    <p className='font-bold text-[16px] md:text-[20px] text-red-600 text-start'>Connect with us</p>
                    <div className='flex items-center gap-[10px] font-semibold text-[14px] md:text-[18px] mt-[10px]'>
                        <MdOutlineWhatsapp className='text-[#27AE60] flex-shrink-0' />
                        <p >+91 90430 66871 (Whatsapp only)</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
